export const data = [
    {
      "title": "Python",
      "imageSrc": require("../assets/python.png"),
    },
    {
      "title": "PostgreSQL",
      "imageSrc": require("../assets/PostgreSQL.png"),
    },
    {
      "title": "MongoDB",
      "imageSrc": require("../assets/MongoDB_logo_01.png"),
    },
    {
      "title": "HTML",
      "imageSrc": require("../assets/HTML5_Badge_512.png"),
    },
    {
      "title": "Java/JavaFX",
      "imageSrc": require("../assets/java.webp"),
    },
    {
      "title": "CSS",
      "imageSrc": require("../assets/CSS3_logo.svg.png"),
    },
    {
      "title": "React",
      "imageSrc": require("../assets/React-icon.svg.png"),
    },
    {
      "title": "JavaScript",
      "imageSrc": require("../assets/javascript-logo.webp"),
    },
    {
      "title": "TypeScript",
      "imageSrc": require("../assets/Typescript_logo_2020.png"),
    },
    {
      "title": "R",
      "imageSrc": require("../assets/R_logo.svg.png"),
    }
  ];
  
  export default data;